import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { LoginRequestsService, LocalStorage, AuthService } from 'finpass-angular-services';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'change-password-modal',
  template: `<div class="fx-modal">
  <div class="fx-modal-header">
        <h1>Alterar senha</h1>
        <i (click)="activeModal.dismiss()" class="fa fa-plus icon-close"></i>
   </div>
   <div class="modal-body">
     <form [formGroup]="form" (ngSubmit)="submit(form)" >
         <div class="clear20"></div>
         <div class="form-group">
             <label>Senha atual *</label>
             <input id="password" formControlName="password" required type="password">
             <form-error [errors]="{minlength: 'Senha muito curta'}" [control]="password"></form-error>
         </div>
         <div class="form-group">
             <label>Nova senha (no mÃ­nimo 6 caractÃ©res) *</label>
             <input id="newPassword" formControlName="newPassword" required type="password">
             <form-error [errors]="{minlength: 'Senha muito curta'}" [control]="newPassword"></form-error>
         </div>
         <div class="form-group">
             <label>Confirmar senha *</label>
             <input id="newPasswordConfirm" formControlName="newPasswordConfirm" required type="password">
             <form-error [errors]="{minlength: 'Senha muito curta'}" [control]="newPasswordConfirm"></form-error>
         </div>
         <button type="submit" [disabled]="!form.valid" class="fx-btn primary">Enviar</button>
     </form>
   </div>
</div>
`,
  styles: [``]
})
export class ChangeModalComponent implements OnInit {
  @Input() entity: string;
  form = this.fb.group({
    password: new FormControl('', [ Validators.required, Validators.minLength(6)]),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    newPasswordConfirm: new FormControl('', [Validators.required, Validators.minLength(6)]),
  },  {validators: this.passwordsMatch});

  loginType: string;

  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private loginService: LoginRequestsService,
    private toastr: ToastrService,
    private localStorage: LocalStorage,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.loginType = this.authService.getType();
  }

  get password(): AbstractControl { return this.form.get('password'); }
  get newPassword(): AbstractControl { return this.form.get('newPassword'); }
  get newPasswordConfirm(): AbstractControl { return this.form.get('newPasswordConfirm'); }

  passwordsMatch(fg) {
      return (fg.controls.newPasswordConfirm || {}).value === (fg.controls.newPassword || {}).value
          ? null : {'mismatch': true};
  }

  submit(fg) {
    const obj = {
      password: fg.get("password").value,
      newPassword: fg.get("newPassword").value,
      newPasswordConfirm: fg.get("newPasswordConfirm").value
    }
    this.loginService.changePassword(obj, this.loginType)
        .subscribe((data) => {
            this.toastr.success('Senha alterada com sucesso!', 'ConfirmaÃ§Ã£o');
            this.activeModal.close(true);
        });
  }
}
